/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { QuestionMetadataDto } from '../models';
import { UpsertQuestionMetadataDto } from '../models';
/**
 * QuestionsMetadataApi - axios parameter creator
 * @export
 */
export const QuestionsMetadataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create or update a QuestionMetadata
         * @param {UpsertQuestionMetadataDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionMetadataControllerUpsertOne: async (body: UpsertQuestionMetadataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling questionMetadataControllerUpsertOne.');
            }
            const localVarPath = `/api/questions-metadata/upsert-one`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsMetadataApi - functional programming interface
 * @export
 */
export const QuestionsMetadataApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create or update a QuestionMetadata
         * @param {UpsertQuestionMetadataDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionMetadataControllerUpsertOne(body: UpsertQuestionMetadataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<QuestionMetadataDto>>> {
            const localVarAxiosArgs = await QuestionsMetadataApiAxiosParamCreator(configuration).questionMetadataControllerUpsertOne(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QuestionsMetadataApi - factory interface
 * @export
 */
export const QuestionsMetadataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create or update a QuestionMetadata
         * @param {UpsertQuestionMetadataDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionMetadataControllerUpsertOne(body: UpsertQuestionMetadataDto, options?: AxiosRequestConfig): Promise<AxiosResponse<QuestionMetadataDto>> {
            return QuestionsMetadataApiFp(configuration).questionMetadataControllerUpsertOne(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionsMetadataApi - object-oriented interface
 * @export
 * @class QuestionsMetadataApi
 * @extends {BaseAPI}
 */
export class QuestionsMetadataApi extends BaseAPI {
    /**
     * 
     * @summary Create or update a QuestionMetadata
     * @param {UpsertQuestionMetadataDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsMetadataApi
     */
    public async questionMetadataControllerUpsertOne(body: UpsertQuestionMetadataDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<QuestionMetadataDto>> {
        return QuestionsMetadataApiFp(this.configuration).questionMetadataControllerUpsertOne(body, options).then((request) => request(this.axios, this.basePath));
    }
}
